module.exports = __webpack_public_path__ + "static/gm-12-961898f88e2aeb4103ff485791c92e08.jpg";